var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.352,
    height: 22.613,
    viewBox: "3.392 1.131 20.352 22.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.482 3.392h-4.726c-.475-1.312-1.718-2.261-3.188-2.261-1.47 0-2.714.95-3.189 2.26H5.653a2.268 2.268 0 0 0-2.261 2.262v15.83a2.268 2.268 0 0 0 2.261 2.26h15.83a2.268 2.268 0 0 0 2.26-2.26V5.652a2.268 2.268 0 0 0-2.26-2.261Zm-7.914 0c.622 0 1.13.509 1.13 1.13 0 .622-.508 1.131-1.13 1.131-.622 0-1.13-.509-1.13-1.13 0-.622.508-1.131 1.13-1.131ZM11.306 19.22l-4.522-4.523 1.594-1.594 2.928 2.917 7.451-7.45 1.595 1.605-9.046 9.045Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "Tracciato 364"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.ae57d72d6b595b144e734a2c0478479d.svg";
export { ForwardRef as ReactComponent };